import api from "../../domain/api";
import {
    GET_BLOGCOMMENTS_STATED,
    GET_BLOGCOMMENTS,
    GET_BLOGCOMMENTS_ENDED,
    ADD_BLOGCOMMENT_STATED,
    ADD_BLOGCOMMENT,
    ADD_BLOGCOMMENT_ENDED,
    EDIT_BLOGCOMMENT_STATED,
    EDIT_BLOGCOMMENT,
    EDIT_BLOGCOMMENT_ENDED,
    GET_BLOGCOMMENT_STATED,
    GET_BLOGCOMMENT,
    GET_BLOGCOMMENT_ENDED,
    GET_ALL_BLOGCOMMENTS_STATED,
    GET_ALL_BLOGCOMMENTS,
    GET_ALL_BLOGCOMMENTS_ENDED,
} from "../types/blogcomment_type";
import * as qs from "qs";
import { handleError } from "../../shared/handleError";
import { setAlert } from "./alert";

export const addBlogcomment = (formData) => async (dispatch, getState) => {
    try {
        dispatch({
            type: ADD_BLOGCOMMENT_STATED,
        });
        const { data } = await api.post(`/blogcomments`, formData);
        dispatch({
            type: ADD_BLOGCOMMENT,
            payload: data,
        });
        dispatch({
            type: ADD_BLOGCOMMENT_ENDED,
        });
    } catch (error) {
        dispatch({
            type: ADD_BLOGCOMMENT_ENDED,
        });
        dispatch(handleErrorLocal(error));
        dispatch(handleError(error));
    }
};
export const getBlogcomments =
    ({ pageNumber = "" }) =>
        async (dispatch) => {
            try {
                dispatch({
                    type: GET_BLOGCOMMENTS_STATED,
                });
                const queryParams = qs.parse(window.location.search.replace("?", ""));
                const query = qs.stringify(queryParams, {
                    encodeValuesOnly: true, // prettify url
                });

                const { data } = await api.get(`/blogcomments?&${query}`);

                dispatch({
                    type: GET_BLOGCOMMENTS,
                    payload: data,
                });
                dispatch({
                    type: GET_BLOGCOMMENTS_ENDED,
                });
            } catch (error) {
                dispatch({
                    type: GET_BLOGCOMMENTS_ENDED,
                });
                dispatch(handleErrorLocal(error));
                dispatch(handleError(error));
            }
        };
export const getBlogcomment = (id) => async (dispatch) => {
    try {
        dispatch({
            type: GET_BLOGCOMMENT_STATED,
        });
        const { data } = await api.get(`/blogcomments/${id}`);

        dispatch({
            type: GET_BLOGCOMMENT,
            payload: data,
        });
        dispatch({
            type: GET_BLOGCOMMENT_ENDED,
        });
    } catch (error) {
        dispatch({
            type: GET_BLOGCOMMENT_STATED,
        });
        dispatch(handleErrorLocal(error));
        dispatch(handleError(error));
    }
};
export const editBlogcomment = (id, formData) => async (dispatch) => {
    try {
        dispatch({
            type: EDIT_BLOGCOMMENT_STATED,
        });
        const { data } = await api.put(`/blogcomments/${id}`, formData);
        dispatch({
            type: EDIT_BLOGCOMMENT,
            payload: data,
        });
        dispatch({
            type: EDIT_BLOGCOMMENT_ENDED,
        });
    } catch (error) {
        dispatch({
            type: EDIT_BLOGCOMMENT_ENDED,
        });
        dispatch(handleErrorLocal(error));
        dispatch(handleError(error));
    }
};
export const deleteBlogcomment = (id) => async (dispatch) => {
    try {
        const { data } = await api.delete(`/blogcomments/${id}`);
        dispatch(setAlert("Blogcomment Deleted Successfully", "success"));
    } catch (error) {
        dispatch(handleErrorLocal(error));
        dispatch(handleError(error));
    }
};
export const getAllBlogcomments =
    ({ term, value }) =>
        async (dispatch) => {
            try {
                dispatch({
                    type: GET_ALL_BLOGCOMMENTS_STATED,
                });
                const { data } = await api.get(`/blogcomments/all?term=${term}&value=${value}`);

                dispatch({
                    type: GET_ALL_BLOGCOMMENTS,
                    payload: data,
                });
                dispatch({
                    type: GET_ALL_BLOGCOMMENTS_ENDED,
                });
            } catch (error) {
                dispatch({
                    type: GET_ALL_BLOGCOMMENTS_ENDED,
                });
                dispatch(handleErrorLocal(error));
                dispatch(handleError(error));
            }
        };

export const handleErrorLocal = () => async (dispatch) => { };
